import { Icon } from '@fluentui/react';

export interface AttachmentIndicatorProps {
  value?: boolean;
}

export function AttachmentIndicator({ value }: AttachmentIndicatorProps) {
  if (value !== true) return null;

  return (
    <span
      role="img"
      aria-label="Has attachments"
      title="Has attachments"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
    >
      <Icon iconName="Attach" aria-hidden="true" style={{ fontSize: 12 }} />
    </span>
  );
}
